import { createSlice } from "@reduxjs/toolkit";
import {
  deleteCandidateCv,
  deleteComment,
  getCandidateById,
  getCommentsByCandidateId,
  upsertComment,
  saveInterviewFeedback,
  getInterviewFeedback,
  getInterviewFeedbackById,
  deleteInterviewFeedback
} from "./Thunk";

export const candidate = createSlice({
  name: "candidate",
  initialState: {
    id: "",
    name: "",
    candidate: {},
    comments: [],
    selectedComment: {},
    selectedResult: null,
    interviewFeedback: [],
    selectedInterviewFeedback: null,

    isLoading: false,
  },
  reducers: {
    SetSelectedComment(state, action) {
      state.selectedComment = action.payload;
    },
    ClearSelectedComment(state, action) {
      state.selectedComment = null;
    },
    SetSelectedResult(state, action) {
      state.selectedResult = action.payload;
    },

    ChangeCommentContent(state, action) {
      state.selectedComment.content = action.payload;
    },

    ClearCandidateState(state) {
      state.id = "";
      state.name = "";
      state.candidate = {};
      state.comments = [];
      state.selectedComment = {};
      state.selectedResult = null;
      state.interviewFeedback = [];
      state.selectedInterviewFeedback = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getCandidateById.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(getCandidateById.fulfilled, (state, action) => {
      state.isLoading = false;
      state.candidate = action.payload;
    });

    builder.addCase(getCommentsByCandidateId.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(getCommentsByCandidateId.fulfilled, (state, action) => {
      state.isLoading = false;
      state.comments = action.payload;
    });

    builder.addCase(upsertComment.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(upsertComment.fulfilled, (state, action) => {
      state.isLoading = false;
    });

    builder.addCase(deleteComment.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(deleteComment.fulfilled, (state, action) => {
      state.isLoading = false;
    });

    builder.addCase(deleteCandidateCv.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(deleteCandidateCv.fulfilled, (state, action) => {
      state.isLoading = false;
    });

    builder.addCase(saveInterviewFeedback.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(saveInterviewFeedback.fulfilled, (state, action) => {
      state.isLoading = false;
      state.interviewFeedback = Array.isArray(action.payload) ? action.payload : [];
    });

    builder.addCase(getInterviewFeedback.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(getInterviewFeedback.fulfilled, (state, action) => {
      state.isLoading = false;
      state.interviewFeedback = Array.isArray(action.payload) ? action.payload : [];
    });

    builder.addCase(getInterviewFeedbackById.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(getInterviewFeedbackById.fulfilled, (state, action) => {
      state.isLoading = false;
      state.selectedInterviewFeedback = action.payload;
    });

    builder.addCase(deleteInterviewFeedback.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(deleteInterviewFeedback.fulfilled, (state, action) => {
      state.isLoading = false;
    });
  },
});

export const { SetSelectedComment, ClearSelectedComment, SetSelectedResult, ChangeCommentContent, ClearCandidateState } = candidate.actions;

export default candidate.reducer;
